import React, { forwardRef, useRef, type TextareaHTMLAttributes } from 'react';
import { firstAdKeyword } from '@shared/createAdKeyword';
import './keyword-brief.css';

type Props = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'value'> & {value:string};
/** Native editing stays intact; the backdrop only paints the active keyword. */
export const KeywordBrief = forwardRef<HTMLTextAreaElement, Props>(function KeywordBrief({value, onScroll, ...props}, ref) {
  const backdrop = useRef<HTMLDivElement>(null);
  const keyword = firstAdKeyword(value);
  return <div className="keyword-brief">
    <div ref={backdrop} className="keyword-brief__backdrop" aria-hidden="true">
      {keyword ? <>{value.slice(0,keyword.start)}<mark data-testid="active-ad-keyword">{value.slice(keyword.start,keyword.end)}</mark>{value.slice(keyword.end)}</> : value}{'\n'}
    </div>
    <textarea {...props} ref={ref} value={value} onScroll={event => {
      if (backdrop.current) {backdrop.current.scrollTop=event.currentTarget.scrollTop;backdrop.current.scrollLeft=event.currentTarget.scrollLeft;}
      onScroll?.(event);
    }} />
    <span className="sr-only" role="status">{keyword ? `${keyword.value} selected. Other ${keyword.axis === 'styles' ? 'angles' : 'styles'} are chosen automatically.` : ''}</span>
  </div>;
});
